import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const WA_NUMBER = "6282327866916";
export const waLink = (text) => `https://wa.me/${WA_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export function LinkShell({ children, title = "AI Business Builder", back = false, testId }) {
  useEffect(() => { document.title = title; }, [title]);
  return (
    <div
      data-testid={testId}
      className="min-h-screen bg-[#fafaf7] text-zinc-900 selection:bg-lime-300"
      style={{ fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}
    >
      <div className="pointer-events-none fixed inset-x-0 top-0 h-72 bg-[radial-gradient(60%_100%_at_50%_0%,rgba(190,242,100,0.35),transparent)]" />
      <main className="relative mx-auto w-full max-w-md px-5 pb-16 pt-8 sm:max-w-lg">
        {back && (
          <Link
            to="/link"
            data-testid="link-back-btn"
            className="mb-6 inline-flex items-center gap-1.5 rounded-full border border-zinc-200 bg-white px-3.5 py-1.5 text-sm font-medium text-zinc-700 transition-colors hover:border-lime-400 hover:text-zinc-900"
          >
            <ArrowLeft className="h-4 w-4" /> Kembali
          </Link>
        )}
        {children}
        <footer className="mt-12 text-center text-xs text-zinc-400">© {new Date().getFullYear()} AI Business Builder · @mudahcarikerja</footer>
      </main>
    </div>
  );
}

export const fadeUp = (i, extra = "") => ({
  className: `lb-fade-up${extra ? ` ${extra}` : ""}`,
  style: { animationDelay: `${i * 70}ms` },
});
